import { Fragment, h } from "preact";

import ProductList from "../helpers/product-list/product-list.jsx";

const SubcollectionContent = ({ data }) => {
  const {
    collectionHandle,
    perPage,
    collectionContent,
    preselectColor,
    productLimit,
  } = data;

  const defaultSortOption = {
    key: "sort_collection_default",
    label: "Featured",
    value: "COLLECTION_DEFAULT",
    reverse: false,
  };

  return (
    <Fragment>
      {/* <div className="subcollection__products"> */}
      <ProductList
        perPage={productLimit || perPage}
        collectionHandle={collectionHandle}
        sortOption={defaultSortOption}
        disableLoadMore={!!productLimit}
        collectionContent={collectionContent}
        preselectColor={preselectColor}
        cardStyle="gradient"
      />
      {/* </div> */}
    </Fragment>
  );
};

export default SubcollectionContent;
